import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteAction, AlertAction, AuthAction, SiteSurveyAction } from '../../actions';
import { RayDelButton } from '../common/Buttons';
import { Translate as t } from '../../config/Translate';
import { formatDisplayDate } from '../../lib/dateDisplay';

const fmtDate = (v) => formatDisplayDate(v);

const SurveyCard = ({ item, DeleteSiteSurvey }) => {

	const [view, setView] = useState(false);
	//const [ t, i18n ] = useTranslation();
	const del = () => {
		DeleteSiteSurvey(item._id);
	}


	return (
		<div className="accordion round-box progress-card mb-1">
			<div className="accordion-item">
				<h2 className="accordion-header">
					<button className="accordion-button collapsed" onClick={() => setView(!view)} style={{ width: "100%" }}>
						<div className="item">
							{!item.isSubmit && <div className="in">
								<div>
									<div className="d-flex align-items-baseline" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
										{item.siteSitename && <h4 className="mb-0">{item.siteSitename}</h4>}
										<small className="text-muted" style={{ fontSize: '0.8rem' }}>
											<strong>{t('common.label.createDate')}</strong>: {fmtDate(item.createDate)} <span aria-hidden="true">·</span> <strong>{t('installation.status.surveyScheduled')}</strong>: {fmtDate(item.scheduleDate)}
										</small>
									</div>
									{item.model && <p>{item.model}</p>}
								</div>
								<div className="price">{item.siteSurveyStep} / 6</div>
							</div>}
							{!item.isSubmit && <div className="progress mt-1">
								<div className="progress-bar bg-success" style={{ width: ((item.siteSurveyStep / 6) * 100) + "%" }}>{Math.round((item.siteSurveyStep / 6) * 100) + "%"}</div>
							</div>}
							{item.isSubmit && <div>
								<ion-icon name="checkmark-circle" size="large" className="text-success fl md hydrated"></ion-icon>
								<div className="d-flex align-items-baseline" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
									{item.siteSitename && <h4 className="mb-0">{item.siteSitename}</h4>}
									<small className="text-muted" style={{ fontSize: '0.8rem' }}>
										<strong>{t('common.label.createDate')}</strong>: {fmtDate(item.createDate)} <span aria-hidden="true">·</span> <strong>{t('installation.status.surveyScheduled')}</strong>: {fmtDate(item.scheduleDate)}
									</small>
								</div>
								{item.model && <p>{item.model}</p>}
							</div>}
						</div>
					</button>
				</h2>
				{view && <div className="accordion-collapse">
					<div className="accordion-body mt-0">
						{!item.isSubmit && <Link to={"/SiteSurvey/" + item._id} className="btn btn-block btn-primary mt-0">{t('common.button.edit')}</Link>}
						{item.isSubmit && <Link to={"/SiteSurvey/" + item._id + "/view"} className="btn btn-block btn-primary mt-0">{t('common.button.view')}</Link>}
						{!item.isSubmit && <RayDelButton css="btn btn-block btn-dark" callback={() => del()} startMsg={t('common.button.delete')} />}
					</div>
				</div>}
			</div>
		</div>
	)
};

const mapDispatch = dispatch => ({
	DeleteSiteSurvey: (_id) => dispatch(SiteSurveyAction.DeleteSiteSurvey(_id)),
})

export default connect(null, mapDispatch)(SurveyCard);